<template>
  <b-card
    title="État général *"
    class="shadow-sm h-100"
  >

    <b-row>

      <b-col>
        <b-form-group
          class="mt-2 mb-0"
          label-for="healthState-input"
          :invalid-feedback="formHealth.healthState.invalidFeedback"
          :state="formHealth.healthState.state"
        >
          <b-form-select
            id="healthState-input"
            :options="healthStates"
            :state="formHealth.healthState.state"
            :value="formHealth.healthState.value"
            @change="$emit('didChangeStatus', $event)"
            required
          ></b-form-select>
        </b-form-group>

      </b-col>

      <b-col>
        <div>
          <b-form-group
            class="mt-2 mb-0"
            label-for="temperature-input"
            :invalid-feedback="formHealth.temperature.invalidFeedback"
            :state="formHealth.temperature.state"
          >
            <b-input-group size="md" append="°C">
              <b-form-input
                id="temperature-input"
                type="text"
                :state="formHealth.temperature.state"
                :value="formHealth.temperature.value"
                @input="$emit('didChangeTemperature', $event)"
                placeholder="Température"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>

      </b-col>
    </b-row>
    <b-row>
      <b-col>
          <b-form-group
            class="mt-2 mb-0"
            label-for="hydration-input"
            :invalid-feedback="formHealth.hydration.invalidFeedback"
            :state="formHealth.hydration.state"
          >
            <b-form-select
              id="hydration-input"
              :options="hydrationOptions"
              :state="formHealth.hydration.state"
              :value="formHealth.hydration.value"
              @change="$emit('didChangeHydration', $event)"
            ></b-form-select>
          </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          class="mt-2 mb-0"
          label-for="weight-input"
          :invalid-feedback="formHealth.weight.invalidFeedback"
          :state="formHealth.weight.state"
        >
          <b-input-group size="md" append="Kg">
            <b-form-input
              id="weight-input"
              type="text"
              :state="formHealth.weight.state"
              :value="formHealth.weight.value"
              @input="$emit('didChangeWeight', $event)"
              placeholder="Poids"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2">

      <b-col>
        <b-form-group
          label-for="healthStateInformation-input"
          class="mb-0"
          :state="formHealth.healthStateInformation.state"
          :invalid-feedback="formHealth.healthStateInformation.invalidFeedback"
        >
          <b-form-textarea
            id="healthStateInformation-input"
            class="mt-1"
            :value="formHealth.healthStateInformation.value"
            @input="$emit('didChangeHealthStateInformation', $event)"
            placeholder="Informations supplémentaires sur l'état de santé..."
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import api from "../../../services/api";

export default {
  name: "DailyStatusCardHealth",

  props: {
    formHealth: {
      type: Object,
      required: true
    }
  },

  data(){
    return {
      healthStates: [],
      hydrationOptions: [
        { text: 'Aucune réhydratation', value: null },
        { text: 'Perfusion intraveineuse', value: "Perfusion intraveineuse" },
        { text: 'Réhydratation sous-cutanée', value: "Réhydratation sous-cutanée" },
      ]
    }
  },

  created () {
    this.fetchHealthStates()
  },

  methods: {
    fetchHealthStates() {
      api
        .get(`/healthState`)
        .then(response => {
          this.healthStates = [{value: null, text: 'État de santé *', disabled: true}]
          response.data.map(healthState => {
            this.healthStates.push({value: healthState.id, text: healthState.name})
          })
        })
    },
  }
}
</script>

<style scoped>
.form-group textarea {
  min-height: auto;
}
.input-group-text {
  padding: 2px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/cards/DailyStatusCardHealth.vue